import * as React from "react";
import { FeaturedProducts } from "@grandvisionhq/products";
import { useIntl } from "@grandvisionhq/state";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachPageName } from "../../../../hooks/hooks/use-bloomreach-page-name.js";
const CmsRecommendedProducts = ({ meta }) => {
  const { getLabel } = useIntl();
  const pageName = useBloomreachPageName();
  const skus = "recommendedProducts" in meta ? meta.recommendedProducts : [meta.product1, meta.product2, meta.product3].filter(Boolean);
  return /* @__PURE__ */ React.createElement(
    FeaturedProducts,
    {
      skus,
      title: getLabel("blog.content.recommendedProducts.title"),
      renderLocation: pageName
    }
  );
};
const CmsRecommendedProducts$1 = compose(
  withBreakpointVisibility,
  withEditableContent,
  withBloomreachData,
  withAnchor
)(CmsRecommendedProducts);
export {
  CmsRecommendedProducts,
  CmsRecommendedProducts$1 as default
};
//# sourceMappingURL=RecommendedProducts.js.map
